import { render, staticRenderFns } from "./FoodTypesSlider.vue?vue&type=template&id=6091b452"
import script from "./FoodTypesSlider.vue?vue&type=script&lang=js"
export * from "./FoodTypesSlider.vue?vue&type=script&lang=js"
import style0 from "./FoodTypesSlider.vue?vue&type=style&index=0&id=6091b452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports